onLoad(() => {
    // Do not load drift if the property is set
    if ('DO_NOT_LOAD_TWITTER' in window) {
        return;
    }
    (function (e, t, n, s, u, a) {
        if (e.twq) {
            return;
        }
        s = e.twq = function () {
            return s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
        };
        s.version = '1.1';
        s.queue = [];
        u = t.createElement(n);
        u.async = !0;
        u.src = '//static.ads-twitter.com/uwt.js';
        a = t.getElementsByTagName(n)[0];
        a.parentNode.insertBefore(u, a);
    })(window, document, 'script');
    twq('init', 'o3ylg');
    twq('track', 'PageView');
});
